export const getDefaultValue = (userProp: string | null | undefined) =>
    userProp || undefined;

export const getPromoType = (variant: string): 'boosted' | 'standard' => {
    if (variant === 'boosted') return variant;
    return 'standard';
};

export const getMemberType = (
    type: string
): 'agent' | 'developer' | undefined => {
    if (type === 'agent' || type === 'developer') {
        return type;
    }
    return;
};
